enum Role {
  Approver = 'tracking-register:approver',
}

export default {
  Role,
};
